import { UtmQuery } from 'mk2/apps/home/schemas';
import { SignupFormData } from 'mk2/apps/users/components/SignupForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Signup form

export const SIGNUP_TRIGGER = 'SIGNUP_TRIGGER';
export interface SignupTriggerAction {
    readonly type: typeof SIGNUP_TRIGGER;
    readonly signupFd: SignupFormData;
    readonly query: UtmQuery;
    readonly iframe: boolean;
    readonly newSignupForm: boolean;
}
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export interface SignupRequestAction extends APIRequestAction {
    readonly type: typeof SIGNUP_REQUEST;
    readonly signupFd: SignupFormData;
    readonly query: UtmQuery;
    readonly newSignupForm: boolean;
}
export interface SignupNormalizedResponse extends NormalizedResponse {
    // readonly result: { topic: number; moderatorsDetails: any; };
}
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export interface SignupSuccessAction extends APISuccessAction<SignupNormalizedResponse> {
    readonly type: typeof SIGNUP_SUCCESS;
    readonly signupFd: SignupFormData;
}
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export interface SignupFailureAction extends APIFailureAction {
    readonly type: typeof SIGNUP_FAILURE;
    readonly signupFd: SignupFormData;
}

export const signupTrigger =  (signupFd: SignupFormData, query: UtmQuery, iframe: boolean, newSignupForm: boolean): SignupTriggerAction => ({
    type: SIGNUP_TRIGGER, signupFd, query, iframe, newSignupForm,
});
export const signupAPI = {
    request: (signupFd: SignupFormData, query: UtmQuery, newSignupForm: boolean): SignupRequestAction => ({
        type: SIGNUP_REQUEST, signupFd, query, newSignupForm,
    }),
    success: (signupFd: SignupFormData, response: SignupNormalizedResponse): SignupSuccessAction => ({
        type: SIGNUP_SUCCESS, signupFd, response,
    }),
    failure: (signupFd: SignupFormData, error: any): SignupFailureAction => ({
        type: SIGNUP_FAILURE, signupFd, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Validation

export const VALIDATE_REGISTRATION_INPUTS_TRIGGER = 'VALIDATE_REGISTRATION_INPUTS_TRIGGER';
export interface ValidateRegistrationInputsTriggerAction {
    readonly type: typeof VALIDATE_REGISTRATION_INPUTS_TRIGGER;
    readonly signupFd: SignupFormData;
    readonly query: UtmQuery;
}
export const VALIDATE_REGISTRATION_INPUTS_REQUEST = 'VALIDATE_REGISTRATION_INPUTS_REQUEST';
export interface ValidateRegistrationInputsRequestAction extends APIRequestAction {
    readonly type: typeof VALIDATE_REGISTRATION_INPUTS_REQUEST;
    readonly signupFd: SignupFormData;
    readonly query: UtmQuery;
}
export interface ValidateRegistrationInputsNormalizedResponse extends NormalizedResponse {
    // readonly result: { topic: number; moderatorsDetails: any; };
}
export const VALIDATE_REGISTRATION_INPUTS_SUCCESS = 'VALIDATE_REGISTRATION_INPUTS_SUCCESS';
export interface ValidateRegistrationInputsSuccessAction extends APISuccessAction<ValidateRegistrationInputsNormalizedResponse> {
    readonly type: typeof VALIDATE_REGISTRATION_INPUTS_SUCCESS;
    readonly signupFd: SignupFormData;
}
export const VALIDATE_REGISTRATION_INPUTS_FAILURE = 'VALIDATE_REGISTRATION_INPUTS_FAILURE';
export interface ValidateRegistrationInputsFailureAction extends APIFailureAction {
    readonly type: typeof VALIDATE_REGISTRATION_INPUTS_FAILURE;
    readonly signupFd: SignupFormData;
}

export const validateRegistrationInputs =  (signupFd: SignupFormData, query: UtmQuery): ValidateRegistrationInputsTriggerAction => ({
    type: VALIDATE_REGISTRATION_INPUTS_TRIGGER, signupFd, query,
});
export const validateRegistrationInputsAPI = {
    request: (signupFd: SignupFormData, query: UtmQuery): ValidateRegistrationInputsRequestAction => ({
        type: VALIDATE_REGISTRATION_INPUTS_REQUEST, signupFd, query,
    }),
    success: (signupFd: SignupFormData, response: SignupNormalizedResponse): ValidateRegistrationInputsSuccessAction => ({
        type: VALIDATE_REGISTRATION_INPUTS_SUCCESS, signupFd, response,
    }),
    failure: (signupFd: SignupFormData, error: any): ValidateRegistrationInputsFailureAction => ({
        type: VALIDATE_REGISTRATION_INPUTS_FAILURE, signupFd, error,
    }),
};
